import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const syncAdminDevices = async () => {
  const signedRequest = await createSignedPostRequest({
    apiPath: 'admin/renolog/sync-devices',
    body: {},
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
